import { useAppSelector } from '@/redux/hooks'
import { SearchIcon } from '@/ui/icons/search'
import { Input } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'

export const StoreSearch = () => {
    const { t } = useTranslation()

    const ecommerceGroup = useAppSelector(
        (store) => store.settingsApi.settings.response.ecommerce_group
    )

    const [searchParams, setSearchParams] = useSearchParams()

    const onSearch = (search: string) => {
        searchParams.set('filter_text', search)
        setSearchParams(searchParams, { replace: true })
    }

    const onClear = () => {
        searchParams.delete('filter_text')
        setSearchParams(searchParams, { replace: true })
    }

    const isMisako = ecommerceGroup === 'misako'
    const isHoff = ecommerceGroup === 'hoff'

    if (isHoff) {
        return (
            <div className="w-full max-w-60">
                <Input
                    type="search"
                    value={searchParams.get('filter_text') ?? ''}
                    onChange={(e) => onSearch(e.target.value)}
                    placeholder={t('full_catalog.search')}
                    aria-label={t('full_catalog.search')}
                    variant="underlined"
                    isClearable
                    onClear={onClear}
                    startContent={
                        <SearchIcon
                            width={18}
                            height={18}
                            className="text-neutral-600"
                        />
                    }
                />
            </div>
        )
    }

    if (isMisako) {
        return (
            <div className="w-full max-w-60">
                <Input
                    type="search"
                    value={searchParams.get('filter_text') ?? ''}
                    onChange={(e) => onSearch(e.target.value)}
                    placeholder={t('full_catalog.search')}
                    aria-label={t('full_catalog.search')}
                    variant="underlined"
                    isClearable
                    onClear={onClear}
                    classNames={{
                        input: 'placeholder:uppercase'
                    }}
                />
            </div>
        )
    }

    return (
        <div className="w-fit max-w-72 flex-1 shrink-0 transition-all focus-within:max-w-96 [&:has(input:not(:placeholder-shown))]:max-w-96">
            <Input
                type="search"
                value={searchParams.get('filter_text') ?? ''}
                onChange={(e) => onSearch(e.target.value)}
                placeholder={t('full_catalog.search') + '...'}
                aria-label={t('full_catalog.search')}
                variant="bordered"
                isClearable
                onClear={onClear}
                startContent={
                    <SearchIcon
                        width={18}
                        height={18}
                        className="pointer-events-none shrink-0 text-neutral-400"
                    />
                }
                classNames={{
                    inputWrapper:
                        'border-solid bg-white rounded-lg md:rounded-lgx',
                    input: 'placeholder:text-neutral-500'
                }}
            />
        </div>
    )
}
